import {Logo} from 'shared';

export function LoadingScreen() {
  return (
    <div className="flex h-screen flex-col items-center justify-center bg-slate1 text-slate12">
      <Logo className="max-w-[80%] sm:max-w-72" variant="loading" />
    </div>
  );
}
